import { useCallback } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { telemetry } from "@/telemetry";

export const useCaptchaToken = (action: string) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  return useCallback(async () => {
    if (!executeRecaptcha) {
      telemetry.trackEvent("captcha_unavailable", { action });
      throw new Error("Captcha is not ready yet. Please try again.");
    }
    return executeRecaptcha(action);
  }, [executeRecaptcha, action]);
};
